import React, { useEffect } from "react";
import HomeSection1 from "../../Components/Home/HomeSection1/HomeSection1";
import HomeSection2 from "../../Components/Home/HomeSection2/HomeSection2";
import HomeSection3 from "../../Components/Home/HomeSection3/HomeSection3";
import HomeSection4 from "../../Components/Home/HomeSection4/HomeSection4";
import styled from "styled-components";
import "../../App.css";
import HomeSection5 from "../../Components/Home/HomeSection5/HomeSection5";
// import ThemeColorPicker from "../../Components/Common/ColorPicker";
// import { Button } from "@mui/material";

export default function Home({setPrimaryColor,primaryColor,secondaryColor,setSecondaryColor}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <HomeWrapper>
     
      <HomeSection1 />
      <HomeSection2 />
      {/* <ThemeColorPicker
          value={primaryColor}
          onChange={setPrimaryColor}
          name="Primary Color"
        />
         <Button
          variant="contained"
          color="primary"
          style={{ marginTop: '20px' }}
        >
          Primary background
        </Button>
        
        <ThemeColorPicker
          value={secondaryColor}
          onChange={setSecondaryColor}
          name="Primary Color"
        /> */}
         {/* <Button
          variant="contained"
          color="secondary"
          style={{ marginTop: '20px' }}
        >
          Primary Button
        </Button> */}
      <HomeSection5/>
      <HomeSection3 />      
      <HomeSection4 />
    </HomeWrapper>
  );
}

const HomeWrapper = styled.div`  
  padding-bottom: 50px;  
`
